/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { t } from 'utils/translates';

import {
  sendRequest,
  selectRequestState,
  selectItemsIds,
  selectItemById
} from 'mt-react-common/common/reducers/list/reducer';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import ListItemLink from '../../../../../../../components/Common/ListItemLink/ListItemLink';

const faqContentsSearchListRN = 'faqContents.lists.faqContentsSearchList';

// eslint-disable-next-line react/prefer-stateless-function
class SearchResult extends Component {
  componentWillMount() {
    this.props.sendRequest();
  }
  render() {
    if (this.props.requestState.inProgress) {
      return <MediumPreLoader />;
    }
    if (this.props.selectItemsIds.length > 0) {
      return (
        <article className="panel panel-default">
          <div className="panel-heading text-center">
            <h3 className="panel-title">
              <i className="fa fa-search fa-lg" /> {t('Найдено')}{' '}
              <strong>{this.props.selectItemsIds.length}</strong>
            </h3>
          </div>
          <div className="panel-body">
            <div className="paper paper-search">
              <div className="paper-list">
                {this.props.selectItemsIds.map(itemId => {
                  const item = this.props.selectItemById(itemId);
                  return (
                    <article>
                      <h3>
                        <Link
                          className="link-dark"
                          to={`/help/reference-information/view/${item.seoUrl}`}
                          dangerouslySetInnerHTML={{ __html: item.searchTitle }}
                        />
                      </h3>
                      <ol className="breadcrumb breadcrumb-small">
                        <ListItemLink to={`/help/reference-information`}>
                          {t('Справка')}{' '}
                        </ListItemLink>
                        {item.parent && item.parent.seoUrl ? (
                          <ListItemLink
                            to={`/help/reference-information/view/${item.parent.seoUrl}`}
                          >
                            {item.parent.title}{' '}
                          </ListItemLink>
                        ) : null}
                        <ListItemLink
                          to={`/help/reference-information/view/${item.seoUrl}`}
                        >
                          {item.title}{' '}
                        </ListItemLink>
                      </ol>

                      <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: item.searchContent }}
                      />
                    </article>
                  );
                })}
              </div>
            </div>
          </div>
        </article>
      );
    }
    return (
      <div className="alert alert-default text-center">
        <p>{t('Статьи, соответствующие вашим требованиям, не найдены')} :-(</p>
      </div>
    );
  }
}

SearchResult.propTypes = {
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  selectItemsIds: PropTypes.arrayOf(PropTypes.shape).isRequired,
  selectItemById: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, faqContentsSearchListRN),
  selectItemsIds: selectItemsIds(state, faqContentsSearchListRN),
  selectItemById: id => selectItemById(state, faqContentsSearchListRN, id)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(faqContentsSearchListRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResult);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentSearch/SearchResult/SearchResult.js